import { authStore } from '../../../lib/authStore';
import { clientStore } from '../../../lib/clientStore';
import { http } from '../../../lib/http';

const auth = {
  login() {},
  logout(cb) {
    // revoca la familia de refresh tokens en el backend (cookie httpOnly);
    // no se espera la respuesta para no bloquear la salida.
    http.post('/api/g/v2/auth/logout').catch(() => {});
    authStore.clear();
    clientStore.clear();
    cb?.();
  },
  isAutenticado() {
    return Boolean(authStore.getToken());
  },
};

export default auth;
